var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.styleType == "bar"
      ? _c(
          "div",
          {
            staticClass: "login-btn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.facebookLogin()
              }
            }
          },
          [
            _c("img", {
              staticClass: "login_icon",
              attrs: { src: require("../../../assets/img/h5_login_fb.png") }
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("m.log_in_using_Facebook")))])
          ]
        )
      : _c(
          "div",
          {
            staticClass: "img_box",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.facebookLogin()
              }
            }
          },
          [
            _c("img", {
              staticClass: "login_other_img",
              attrs: { src: require("../../../assets/img/h5_login_icon12.png") }
            })
          ]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34e518e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e518e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/LoginSdk/LoginSdkFacebook.vue
// module id = null
// module chunks = 